import { CSSResultGroup, html, LitElement } from 'lit'
import { customElement, state, property } from 'lit/decorators.js'
import { style } from './hotspot-target.style.js'
import { classMap } from 'lit/directives/class-map.js'
import { initializeIconsByRole } from '@cloudsuite/mosaic-shared/icons/library.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { inject } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'
import { BREAKPOINTS, ConcreteBreakpoints } from '@cloudsuite/mosaic-shared/scripts/breakpoints.js'
import { breakpoints } from '@cloudsuite/mosaic-shared/styles/breakpoints.js'
import { createEffect } from '@cloudsuite/mosaic-shared/scripts/signals.js'


initializeIconsByRole({
  'cse-hotspot-target.target': { name: 'plus', style: 'light' }
})

@customElement('cse-hotspot-target')
export class CSEHotspotTarget extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, style]

  @inject(BREAKPOINTS)
  private breakpoints!: ConcreteBreakpoints

  @state()
  smallScreen = false

  @property({ type: String, attribute: 'aria-label' })
  override ariaLabel = ''

  constructor() {
    super()

    this.breakpoints.matchMedia(breakpoints.medium)

    createEffect(() => {
      this.smallScreen = this.breakpoints.small()
    })
  }

  override render() {
    return html`
      <button
        type="button"
        class="${classMap({
          'cse-hotspot-target': true,
          [`size-${this.smallScreen ? 'small' : 'large'}`]: true,
        })}"
        aria-label="${this.ariaLabel}"
        tabindex="0"
      >
        <cse-icon icon-role="cse-hotspot-target.target" size="${this.smallScreen ? 'sm' : 'lg'}"></cse-icon>
      </button>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cse-hotspot-target': CSEHotspotTarget
  }
}
